import React, { useState, forwardRef, useEffect } from 'react'
import {
  Modal,
  Row,
  Col,
  Button,
  FormGroup,
  Form,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap'
import Select, { components } from 'react-select'
//import * as Icons from 'react-feather'
//import MaterialTable from 'material-table'
import FeatherIcon from 'feather-icons-react'
import MaterialTable from '@material-table/core'
import httpClient from 'utility/httpClient.util'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Icon from './Icon'
import Editor, { useMonaco } from '@monaco-editor/react'
//import ThaiDatePicker from 'components/atoms/custom/global/input/ThaiDatePicker'
import ThaiDatePicker from 'designer/component/element/DatePicker/DatePickerCustom'
import DatePickerCustom from 'components/DatePicker/DatePickerCustom'
import { parseFirst } from 'pgsql-ast-parser'
import {
  Edit,
  Delete,
  Search,
  ChevronLeft,
  ChevronRight,
  FirstPage,
  LastPage,
  ArrowDownward,
  Add,
  Clear,
  Check,
} from '@material-ui/icons'
import { FormControlLabel, FormControl, FormLabel, Checkbox, Radio, RadioGroup } from "@material-ui/core";
//import ReactJson from 'react-json-view'
import './MonacoEditor.scss'
import moment from 'moment'

const tableIcons = {
  Add: forwardRef((props, ref) => <Add {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <Delete {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
}

const { Option } = components
const IconOption = (props) => (
  <Option {...props}>
    <Icon name={props.data.iconName} />
    <span style={{ marginLeft: '5px' }}>{props.data.label}</span>
  </Option>
)

const CustomSingleValue = ({ data }) => (
  <div className="input-select">
    <div className="input-select__single-value">
      <Icon name={data.iconName} />
      <span style={{ marginLeft: '5px' }}>{data.label}</span>
    </div>
  </div>
)

const SIZE_OPTIONS = [
  { label: 'A4', value: 'A4' },
  { label: 'Letter', value: 'Letter' },
  { label: 'Custom', value: 'Custom' },
]

// function parseQuery(value) {
//   let state = { columns: [], inputs: [] }
//   let res = value.split('from')
//   let resB = value.split('FROM')
//   if (res.length < 2 && resB.length < 2) {
//     return state
//   }
//   if (resB >= 2) {
//     res = resB
//   }
//   let res2 = res[0].split('select')
//   let res3 = res2[1].split(',')

//   state['columns'] = res3.reduce((result, item, index) => {
//     if (item.trim() != '') {
//       let findex = item.toLowerCase().lastIndexOf('as')
//       if (findex >= 0) {
//         item = item.substring(findex + 3)
//       }
//       item = item.split('"').join('').trim()
//       result.push(item)
//     }
//     return result
//   }, [])

//   let re = /\([^)]*\)|\{{[^\}}]*\}}/g
//   let m = value.match(re)
//   if (Array.isArray(m)) {
//     state['inputs'] = m.reduce((result, item) => {
//       if (item.indexOf('{{') >= 0 && item.indexOf('}}') >= 0) {
//         item = item.split('"').join('').trim()
//         result.push(item)
//       }
//       return result
//     }, [])
//   }

//   console.log('state', state)
//   return state
// }

const SAMPLE_QUERY =
  'select hn,"givenName","familyName" from "Pas"."Patient" as p where p.hn=\'{{hn}}\''
const DEFAULT_STATE = {
  dataSourceId: 0,
  name: '',
  dataSourceName: '',
  dataSourceVariableName: '',
  categoryName: '',
  categoryId: '',
  columns: [],
  query: '',
  inputs: [],
  dataSourceType: 'db',
  apiHeaders: [],
  apiUrl:'',
  apiRespFunc:null
}
const HINT_PARAM = ['an', 'hn', 'vn', 'startDate', 'endDate', 'id', 'name', 'doctor', 'noteId', 'year', 'dn', 'date', 'startBill', 'endBill', 'ward', 'depCode', 'requestNo', 'drugItemCode', 'bookNo'];
const HINT_SCHEMA = []//['IPD','OPD','CoreSystem',"Medication","Lab","Xray","Adr","Accounting","Dental","Nutrition","Ots","SocialWorker","Stock","ExportData","Finance","Media","Ncmc","Pas","Hr"];
//const EMPTY_STATE= {dataSourceId:0,dataSourceName:'',moduleName:'',columns:['hn','firstName','lastName'],query:SAMPLE_QUERY,inputs:[]}
const OPTIONAL_BLOCK_SAMPLE = `{{#optional id}}
and ppc."patientPrescriptionCollectionId" in ('{{id}}')
{{/optional}}`

const OPTIONAL_BLOCK_FULL_SAMPLE = `where ipa.an = '{{an}}'
and pp2."orderNo" = '{{orderNo}}'

{{#optional id}}
and ppc."patientPrescriptionCollectionId" in ('{{id}}')
{{/optional}}`

const OPTIONAL_BLOCK_REGEX = /{{#optional\s+([A-Za-z0-9_.-]+)\s*}}([\s\S]*?){{\/optional}}/g

const isOptionalDirectiveInput = (value = '') => {
  const param = `${value || ''}`
    .trim()
    .replace(/^\{\{/, '')
    .replace(/\}\}$/, '')
    .trim()

  return param.startsWith('#optional') || param.startsWith('/optional')
}

const normalizeInputs = (inputs = []) => [
  ...new Set((inputs || []).filter((item) => item && !isOptionalDirectiveInput(item))),
]

const hasParamValue = (value) => {
  if (Array.isArray(value)) return value.length > 0
  if (value === null || value === undefined) return false
  if (typeof value === 'string') return value.trim() !== ''
  return true
}

const stripOptionalBlockMarkers = (value = '') =>
  `${value || ''}`.replace(
    OPTIONAL_BLOCK_REGEX,
    (_match, _paramName, optionalSql) => optionalSql,
  )

const getOptionalParamValue = (params = {}, paramName = '') => {
  const name = `${paramName || ''}`.trim()
  if (Object.prototype.hasOwnProperty.call(params, name)) return params[name]
  return params[`{{${name}}}`]
}

const applyOptionalBlocks = (value = '', params = {}) =>
  `${value || ''}`.replace(
    OPTIONAL_BLOCK_REGEX,
    (_match, paramName, optionalSql) =>
      hasParamValue(getOptionalParamValue(params, paramName)) ? optionalSql : '',
  )

const replaceAllParam = (value, param, nextValue) =>
  `${value || ''}`.split(param).join(nextValue)

const dataSourceVariableNamePattern = /^[A-Za-z_][A-Za-z0-9_]*$/
const normalizeDataSourceVariableName = (value = '') => `${value || ''}`.trim()
const isValidDataSourceVariableName = (value = '') => {
  const variableName = normalizeDataSourceVariableName(value)
  return !variableName || dataSourceVariableNamePattern.test(variableName)
}
const normalizeDataSourceCategoryId = (value) => {
  if (value === '' || value === null || value === undefined) return undefined

  const categoryId = Number(value)
  return Number.isFinite(categoryId) && categoryId > 0 ? categoryId : undefined
}

export const EditDataSourceModal = ({
  show,
  mode,
  onHide,
  onSave,
  value,
  categoryList,
}) => {
  //console.log('edit',value)
  //value = {...{dataSourceName:"",module:"",columns:["hn","firstName","lastName"],query:'select hn,firstName,lastName,age from "Pas"."Patient" as p where p.hn="{{hn}}"',inputs:[]},value}
  //value = Object.assign(value,parseQuery(value.query))
  const monaco = useMonaco();
  const [state, setState] = useState(DEFAULT_STATE)
  const [queryData, setQueryData] = useState([])
  const [textQuery, setTextQuery] = useState('')
  const [dataSourceListOptions, setDataSourceListOptions] = useState([])
  const [dsValue, setDsValue] = useState({})
  const [queryParserError, setQueryParserError] = useState('')
  const [showOptionalHelp, setShowOptionalHelp] = useState(false)

  useEffect(() => {
    if (monaco) {
      const { dispose } = monaco.languages.registerCompletionItemProvider('sql', {
        triggerCharacters: ['\''],
        provideCompletionItems: () => {
          const suggestions = HINT_PARAM.map((item, index) => {
            return {
              label: '{{' + item + '}}',
              kind: monaco.languages.CompletionItemKind.Field,
              insertText: '{{' + item + '}}'
            }
          })
          return { suggestions };
        }
      });

      return () => {
        dispose()
      }
    }
  }, [monaco]);


  useEffect(() => {
    let newValue = getInitState()
    if (mode !== 'search') {
      newValue = Object.assign(
        getInitState(),
        value,
        value.query ? queryParser(value.query) : {}
      )
      if(value?.dataSourceType=='api'){
        newValue = Object.assign(newValue,apiParser(value?.apiUrl))
      }
    }
    if (value.query) newValue.query = value.query

    //console.log('e', mode, value)
    //console.log('new', newValue,categoryList)
    if (!value.categoryId && value.categoryName) {
      let find = categoryList.find((item) => item.label === value.categoryName)
      if (find) {
        newValue.category = find
        newValue.categoryId = find.value
      }
    }
    setState({ ...newValue })
  }, value)

  const getInitState = () => {
    return {
      dataSourceId: 0,
      name: '',
      dataSourceVariableName: '',
      categoryName: '',
      categoryId: '',
      category: null,
      columns: [],
      query: '',
      inputs: [],
      dataSourceType: 'db',
      apiHeaders: [],
      apiUrl: '',
      apiRespFunc:null
    }
  }

  const updateData = async (field, value, item = {}) => {
    //console.log('v',field,value,item)
    let parse = {}
    if (field == 'query') {
      parse = queryParser(value)
      //setTextQuery(value)
    } else if(field=='apiUrl'){
      parse = apiParser(value)
    } else if (field == 'categoryId') {
      let initState = getInitState()
      if (mode === 'new') {
        delete initState.query
      }
      const find = categoryList.find((item) => item.value === value)

      parse = Object.assign({}, initState, { category: find })
      setDataSourceListOptions([])
      setDsValue({ label: '' })

    } else if (field == 'name') {
      //Update
      if (item.item) {
        parse = item.item
        if (parse.params) {
          parse['inputs'] = normalizeInputs(parse.params.inputs)
        }

        //setTextQuery(parse.query)

        setDsValue(item)
      }
      // console.log('p',parse,value,dataSourceListOptions)
    }
    //console.log('state',state)
    //console.log('parse',parse)
    let newState = Object.assign(state, parse, { [field]: value })
    //console.log('new',newState)
    setState({ ...newState })

    if (field === 'categoryId') {
      await searchDataSource(value)
    }
  }

  const alertQueryError = () => {
    return Swal.fire({
      icon: 'error',
      title: 'เกิดข้อผิดพลาด!',
      html: `<textarea readonly style="width: 380px; height: 200px; font-size: 14px">${queryParserError}</textarea>`,
    })
  }

  const validateDataSourceVariableName = () => {
    const dataSourceVariableName = normalizeDataSourceVariableName(
      state.dataSourceVariableName,
    )

    if (!isValidDataSourceVariableName(dataSourceVariableName)) {
      withReactContent(Swal).fire({
        icon: 'warning',
        title: 'ชื่อตัวแปรไม่ถูกต้อง',
        text: 'กรุณาใช้ตัวอักษรภาษาอังกฤษ ตัวเลข หรือ _ และต้องไม่ขึ้นต้นด้วยตัวเลข',
      })
      return null
    }

    return dataSourceVariableName
  }

  const alertSaveError = (error) => {
    const responseData = error?.response?.data || error?.data || {}
    const message =
      responseData?.message ||
      responseData?.error ||
      error?.message ||
      'ไม่สามารถบันทึกข้อมูลได้'

    withReactContent(Swal).fire({
      icon: 'error',
      title: 'บันทึกไม่สำเร็จ',
      text: message,
    })
  }

  const copyOptionalSyntax = async (text = '') => {
    try {
      await navigator.clipboard.writeText(text)
      withReactContent(Swal).fire({
        icon: 'success',
        title: 'คัดลอกแล้ว',
        text: 'นำ syntax ไปวางใน query ได้เลย',
        timer: 1200,
        showConfirmButton: false,
      })
    } catch (error) {
      withReactContent(Swal).fire({
        icon: 'error',
        title: 'คัดลอกไม่สำเร็จ',
        text: 'กรุณาเลือก syntax แล้ว copy ด้วยตนเอง',
      })
    }
  }

  const apiParser = (value)=>{
    let state = { columns: [], inputs: [] }
    if (value) {
      let re = /\([^)]*\)|\{{[^\}}]*\}}/g
      let m = value.match(re)

      if (Array.isArray(m)) {
        state.inputs = m.reduce((result, input) => {
          const getParam = (result, item) => {
            if (item.indexOf('{{') >= 0 && item.indexOf('}}') >= 0) {
              item = item.split('"').join('').trim()

              let headIndex = item.indexOf('{{')
              let tailIndex = item.indexOf('}}')
              let newItem = item.substring(headIndex, tailIndex + 2)
              let leftItem = item.substring(tailIndex + 2, item.length - 1)

              result.push(newItem)
              getParam(result, leftItem)
              return result
            }
            return result
          }
          result = getParam(result, input)

          return result
        }, [])
      }
      state.inputs = normalizeInputs(state.inputs)
    }
    return state
  }

  const queryParser = (value) => {
    let state = { columns: [], inputs: [] }
    const parseValue = stripOptionalBlockMarkers(value)

    if (parseValue) {
      try {
        const ast = parseFirst(parseValue)

        state.columns = ast.columns.reduce((items, item) => {
          if (item.alias) {
            items.push(item.alias?.name)
          } else {
            items.push(item.expr?.name)
          }
          return items
        }, [])

        setQueryParserError()
      } catch (error) {
        setQueryParserError(error)
        console.error(error)
      }

      let re = /\([^)]*\)|\{{[^\}}]*\}}/g
      let m = parseValue.match(re)

      if (Array.isArray(m)) {
        state.inputs = m.reduce((result, input) => {
          const getParam = (result, item) => {
            if (item.indexOf('{{') >= 0 && item.indexOf('}}') >= 0) {
              item = item.split('"').join('').trim()

              let headIndex = item.indexOf('{{')
              let tailIndex = item.indexOf('}}')
              let newItem = item.substring(headIndex, tailIndex + 2)
              let leftItem = item.substring(tailIndex + 2, item.length - 1)

              result.push(newItem)
              getParam(result, leftItem)
              return result
            }
            return result
          }
          result = getParam(result, input)

          return result
        }, [])
      }
      state.inputs = normalizeInputs(state.inputs)
      return state
    }
  }

  const onModalSave = async () => {
    checkQuery()
    const dataSourceVariableName = validateDataSourceVariableName()
    if (dataSourceVariableName === null) return
    // if (queryParserError) {
    //   alertQueryError()
    // } else {
    const postData = Object.assign(
      { active: 'Y' },
      {
        name: state.name,
        categoryId: normalizeDataSourceCategoryId(state.categoryId),
        query: state.query,
        params: { inputs: normalizeInputs(state.inputs) },
        columns: state.columns,
        fieldVariable: { columns: state.columns },
        dataSourceType:state?.dataSourceType ||'db',
        apiUrl:state?.apiUrl,
        apiHeaders:state?.apiHeaders,
        apiRespFunc:state?.apiRespFunc
      }
    )

    try {
      if (state.dataSourceId > 0) {
        postData.dataSourceId = state.dataSourceId
        await httpClient.put(
          `/report/data-sources/${state.dataSourceId}`,
          postData
        )

        if (mode === 'edit') {
          onHide()
        }
      } else {
        const result = await httpClient
          .post(`/report/data-sources`, postData)
          .then(({ data }) => data.data)
        if (result.dataSourceId) {
          state.dataSourceId = result.dataSourceId
          postData.dataSourceId = result.dataSourceId

          onHide()
        }
      }
    } catch (error) {
      alertSaveError(error)
      return
    }

    if (onSave && mode !== 'search') {
      const reportData = Object.assign({}, postData, {
        dataSourceVariableName,
      })
      if (normalizeInputs(state.inputs).length == 0) {
        //Example data
        reportData.fieldVariable['value'] = queryData
      }
      onSave(reportData)
      //onHide()
    }
    withReactContent(Swal).fire({
      icon: 'success',
      title: 'บันทึกสำเร็จ',
      text: 'ทำการบันทึกสำเร็จ',
    })
    // }
  }

  const onModalDelete = async () => {
    const result = await httpClient
      .delete(`/report/data-sources/${state?.dataSourceId}`)
      .then(({ data }) => data.message)
    if (result === 'success') {
      onHide()
      //ลบ ok
    }
  }

  const onMenuOpen = async () => {
    return;
    console.log('onMenuOpen', dataSourceListOptions, state)
    if (
      dataSourceListOptions.length == 0 ||
      (dataSourceListOptions.length > 0 &&
        dataSourceListOptions[0].categoryId !== state.categoryId)
    ) {
      let list = await httpClient
        .get(
          `/report/data-sources/find?categoryId=${state.categoryId}`
        )
        .then(({ data }) => data.data)
      setDataSourceListOptions(
        list.map((item, index) => {
          return {
            label: item.name,
            value: item.dataSourceId,
            item: item,
          }
        })
      )

      console.log('query list', list)
    }
  }

  const searchDataSource = async (categoryId) => {
    let list = await httpClient
      .get(
        `/report/categories/${categoryId}/data-sources`
      )
      .then(({ data }) => data.data)
    setDataSourceListOptions(
      list.map((item, index) => {
        return {
          label: item.name,
          value: item.dataSourceId,
          item: item,
        }
      })
    )
  }

  const onModalSelect = () => {
    const dataSourceVariableName = validateDataSourceVariableName()
    if (dataSourceVariableName === null) return

    if (onSave) {
      onSave(Object.assign({}, state, { dataSourceVariableName }))
      onHide()
    }
  }

  const renderInput = (title, field) => {
    let value = state[field]
    return (
      <FormGroup>
        <Form.Label for="value" className="text-sm-right">
          {title}
        </Form.Label>
        <Form.Control
          type="text"
          name="value"
          autoComplete="off"
          value={value}
          onChange={(e) => updateData(field, e.target.value)}
        />
      </FormGroup>
    )
  }

  const renderDataSourceVariableNameInput = () => {
    return (
      <FormGroup>
        <Form.Label for="dataSourceVariableName" className="text-sm-right">
          ชื่อตัวแปร Data Source
        </Form.Label>
        <Form.Control
          type="text"
          name="dataSourceVariableName"
          autoComplete="off"
          placeholder="เช่น charge"
          value={state.dataSourceVariableName || ''}
          onChange={(e) => updateData('dataSourceVariableName', e.target.value)}
        />
        <Form.Text className="text-muted">
          ใช้เตรียม token ใน TinyMCE เช่น {'{charge.amount}'}
        </Form.Text>
      </FormGroup>
    )
  }

  const renderTable = () => {
    return (
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          icons={tableIcons}
          columns={state.columns.map((item, index) => {
            let title = item ? item.split('"').join('').trim() : ''

            return {
              title: title,
              field: title,

              render: (rowData) => {
                if (
                  typeof rowData[title] === 'object' &&
                  rowData[title] !== null
                ) {
                  // console.log(rowData[title])
                  // return (
                  //   <ReactJson
                  //     src={rowData[title]}
                  //     name={title}
                  //     collapsed={0}
                  //   />
                  // )
                  const value = rowData[title];
                  return (
                    <div style={{ maxWidth: '300px', overflowX: 'auto' }}>
                      <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
                        {JSON.stringify(value, null, 2)}
                      </pre>
                    </div>
                  );
                  //return rowData[title]
                } else {
                  return rowData[title]
                }
              },
              cellStyle: {
                verticalAlign: 'baseline',
                whiteSpace: 'nowrap',
              },
              headerStyle: {
                whiteSpace: 'nowrap',
              },
            }
          })}
          // columns={queryColumn}
          data={queryData}
          title="ตัวอย่างข้อมูล (ถูก limit ไว้สูงสุด 20 records)"
        />
      </div>
    )
  }

  const checkAPI = async ()=>{
    let apiUrl = state.apiUrl
    let parse = apiParser(state.apiUrl)
    normalizeInputs(state.inputs).forEach((item, index) => {
      console.log('item', item)
      if (isDateInput(item)) {
        if (moment(state[item], moment.ISO_8601, true).isValid()) {
          // Format the date to 'yyyy-mm-dd'
          state[item] = moment(state[item]).format('YYYY-MM-DD');
        }
      }
      if (!state[item]) {
        state[item] = ''
      }
      apiUrl = replaceAllParam(apiUrl, item, state[item])
    })
    let list = []
    let httpResult = await httpClient
      .post('/report/data-sources/test-api', { url: apiUrl })
      .then(({ data }) => data)
      .catch((result) => {
        //Error
        withReactContent(Swal).fire({
          icon: 'error',
          title: 'Error',
          text: result.data ? result.data.message : '',
        })
        return []
      })
    if (queryParserError) {


      const executeFunction = new Function("data", state['apiRespFunc'] + `
        if (typeof apiRespFunc !== "function") {
            throw new Error("Function not defined");
        }
        return apiRespFunc(data);`);

      try{
        list = executeFunction(httpResult); // Output: Alice, Bob
      }catch (error) {
        list = []
      }
      setState({
        ...state,
        parse,
        columns: list?.length > 0 ? Object.keys(list[0]) : [],
      });
    } else {
      setState({
        ...state,
        parse
      });
    }

    setQueryData(list)
  }


  const checkQuery = async () => {
    if(state.dataSourceType==='api'){
      return await checkAPI()
    }
    let parse = queryParser(state.query)
    //console.log('parse', parse, state.query)

    let query = applyOptionalBlocks(state.query, state)
    normalizeInputs(state.inputs).forEach((item, index) => {
      console.log('item', item)
      if (isDateInput(item)) {
        if (moment(state[item], moment.ISO_8601, true).isValid()) {
          // Format the date to 'yyyy-mm-dd'
          state[item] = moment(state[item]).format('YYYY-MM-DD');
        }
      }
      if (!state[item]) {
        state[item] = ''
      }
      query = replaceAllParam(query, item, state[item])
    })
    
    // if (queryParserError) {
    //   alertQueryError()
    // } else {
    let list = await httpClient
      .post('/report/data-sources/test-query', { sql: query })
      .then(({ data }) => {
        if (data.statusCode && data.statusCode >= 400) {
          throw data; // force เข้า catch
        }
        return data.data;
      })
      .catch((result) => {
        //Error
        //console.log('r',result)
        withReactContent(Swal).fire({
          icon: 'error',
          title: 'Error',
          text: result?.data?.message || result.message,
        })
        return []
      })
    if (queryParserError) {
      setState({
        ...state,
        parse,
        columns: list?.length > 0 ? Object.keys(list[0]) : [],
      });
    } else {
      setState({
        ...state,
        parse,
      });
    }

    setQueryData(list)
    // }
  }

  const renderModuleSelect = () => {
    let item = categoryList.find((e) => e.value === state.categoryId)

    return (
      <FormGroup>
        <div>Category / หมวดหมู่</div>
        <div style={{ width: '100%' }}>
          <Select
            name="category"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            placeholder="เลือก Category"
            // maxMenuHeight={moduleList.length > 0 ? 48 * moduleList.length : 48}
            options={categoryList}
            value={state.category}
            onChange={async (e) => {
              //debugger
              await updateData('categoryId', e.value)
            }}
            components={{ Option: IconOption, SingleValue: CustomSingleValue }}
          ></Select>
        </div>
      </FormGroup>
    )
  }

  const renderNewDataSource = () => {
    return (
      <Row>
        <Col md={3}>{renderModuleSelect()}</Col>
        <Col md={5}>{renderInput('ชื่อ Data Source', 'name')}</Col>
        <Col md={4}>{renderDataSourceVariableNameInput()}</Col>
      </Row>
    )
  }

  const renderDateInput = (title, field) => {
    return (
      <FormGroup>
        <Form.Label for="value" className="text-sm-right">
          {title}
        </Form.Label>
        <DatePickerCustom
          disabled={false}
          value={state[field]}
          onChange={(item) => {
            //console.log(item.en)
            updateData(field, item.value)
          }}
          clearable={true}
        // className="mr-md-0 pr-xl-0"
        />
      </FormGroup>
    )
  }

  const isDateInput = (title) => {
    return title.toLowerCase().indexOf('date') >= 0
  }

  const renderSearchDataSource = () => {
    return (
      <Row>
        <Col md={3}>{renderModuleSelect()}</Col>
        <Col md={5}>
          <FormGroup>
            <div>ชื่อ Data Source</div>
            <div style={{ width: '100%' }}>
              <Select
                name="name"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                menuPortalTarget={document.body}
                placeholder="ชื่อ Data Source"
                options={state.categoryId ? dataSourceListOptions : []}
                value={dsValue}
                onMenuOpen={() => {
                  onMenuOpen()
                }}
                onChange={async (e) => {
                  await updateData('name', e.label, e)
                }}
              ></Select>
            </div>
          </FormGroup>
        </Col>
        <Col md={4}>{renderDataSourceVariableNameInput()}</Col>
      </Row>
    )
  }

  const editorDidMount = (editor, monaco) => {
    console.log('editorDidMount', editor, monaco)
    editor.focus()
  }

  const options = {
    selectOnLineNumbers: true,
    roundedSelection: false,
    readOnly: false,
    cursorStyle: 'line',
    automaticLayout: false,
    theme: 'vs',
    scrollbar: {
      // Subtle shadows to the left & top. Defaults to true.
      useShadows: false,
      // Render vertical arrows. Defaults to false.
      verticalHasArrows: true,
      // Render horizontal arrows. Defaults to false.
      horizontalHasArrows: true,
      // Render vertical scrollbar.
      // Accepted values: 'auto', 'visible', 'hidden'.
      // Defaults to 'auto'
      vertical: 'visible',
      // Render horizontal scrollbar.
      // Accepted values: 'auto', 'visible', 'hidden'.
      // Defaults to 'auto'
      horizontal: 'visible',
      verticalScrollbarSize: 17,
      horizontalScrollbarSize: 17,
      arrowSize: 30,
    },
  }

  const onDatasourceTypeChange = (e) => {
    updateData('dataSourceType', e.target.value)
  }

  const renderDSType = () => {
    return (<Row>
      <Col md="12">
        <FormControl component="fieldset">
          <FormLabel component="legend">Datasource Type</FormLabel>
          <RadioGroup aria-label="datasource-type" name="datasource-type" value={state.dataSourceType} onChange={onDatasourceTypeChange} row>
            <FormControlLabel value="db" control={<Radio />} label="Database" style={{ display: 'block' }} />
            <FormControlLabel value="exdb" control={<Radio />} label="External Database" style={{ display: 'block' }} />
            <FormControlLabel value="api" control={<Radio />} label="API" style={{ display: 'block' }} />
          </RadioGroup>
        </FormControl>
      </Col>
    </Row>)
  }

  const addHeader = ()=>{
    setState(prevState => ({
      ...prevState,
      apiHeaders: [...prevState.apiHeaders, { key: "", value: "" }] // Add empty header
    }));
  }

  const removeHeader = (index) => {
    setState(prevState => ({
      ...prevState,
      apiHeaders: prevState.apiHeaders.filter((_, i) => i !== index) // Remove item at index
    }));
  };
  

  const renderDSAPI = () => {
    return (
      <div>
        <Row>
          <Col md={12}>{renderInput('Enter GET URL or Paste Text', 'apiUrl')}</Col>
        </Row>
        Header      <Button onClick={() => addHeader()}>
              <FeatherIcon
                size="16"
                icon="plus"
                className="vx-icon "
              />

              เพิ่ม
            </Button>
        {state.apiHeaders.map((item,index) => (
          <Row className='mb-1'>
            <Col md={4} className='d-flex'>
            <Button color="danger" variant='outline-danger' className='mr-1' onClick={() => removeHeader(index)}>
              <FeatherIcon
                size="16"
                icon="trash"
                className="vx-icon "
              />
            </Button>
            <Form.Control
              type="text"
              name="value"
              autoComplete="off"
              value={item.key}
              onChange={(e) => {

                  const updatedHeaders = [...state.apiHeaders];
                  updatedHeaders[index].key = e.target.value;
                  setState({ ...state, apiHeaders: updatedHeaders });                
                }
              }
            /></Col>
            <Col md={8}><Form.Control
              type="text"
              name="value"
              autoComplete="off"
              value={item.value}
              onChange={(e) => {
                  const updatedHeaders = [...state.apiHeaders];
                  updatedHeaders[index].value = e.target.value;
                  setState({ ...state, apiHeaders: updatedHeaders });
                }
              }
            /></Col>
          </Row>
        ))}
      </div>
    )
  }

  const handleEditorDidMount = (editor, monaco) => {
    // Optionally, you can register additional languages or features here
    monaco.editor.setModelLanguage(editor.getModel(), 'javascript');
  };

  const renderOptionalHelpButton = () => (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="datasource-optional-help">วิธีใช้ Optional Query Block</Tooltip>}
    >
      <Button
        variant="outline-info"
        size="sm"
        className="ml-1 px-1"
        onClick={() => setShowOptionalHelp(true)}
      >
        <FeatherIcon size="14" icon="help-circle" className="vx-icon" />
      </Button>
    </OverlayTrigger>
  )

  const renderSyntaxBlock = (title, syntax, tooltipId) => (
    <div className="mb-2">
      <div className="d-flex justify-content-between align-items-center mb-50">
        <strong>{title}</strong>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={tooltipId}>คัดลอก syntax</Tooltip>}
        >
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => copyOptionalSyntax(syntax)}
          >
            <FeatherIcon size="14" icon="copy" className="vx-icon mr-50" />
            Copy
          </Button>
        </OverlayTrigger>
      </div>
      <pre
        style={{
          background: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '4px',
          padding: '12px',
          whiteSpace: 'pre-wrap',
          marginBottom: 0,
        }}
      >
        <code>{syntax}</code>
      </pre>
    </div>
  )

  const renderOptionalHelpModal = () => (
    <Modal
      show={showOptionalHelp}
      onHide={() => setShowOptionalHelp(false)}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title as="h5">Optional Query Block</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          ใช้สำหรับ condition ที่จะใส่เพิ่มเฉพาะตอนมีค่า param เท่านั้น เช่น
          เลือกกรองรายการยาเฉพาะบาง id แต่ถ้าไม่ส่ง id มา ให้ตัดเงื่อนไขนี้ออก
        </p>
        {renderSyntaxBlock('Syntax สั้น', OPTIONAL_BLOCK_SAMPLE, 'copy-optional-short-syntax')}
        {renderSyntaxBlock('ตัวอย่าง query', OPTIONAL_BLOCK_FULL_SAMPLE, 'copy-optional-query-syntax')}
        <div className="text-muted">
          หมายเหตุ: ชื่อหลัง <code>#optional</code> ต้องตรงกับ param ข้างใน เช่น{' '}
          <code>id</code> และ param ใน optional block จะไม่ถูกบังคับกรอกถ้าไม่มีค่าจาก URL หรือ props
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={() => setShowOptionalHelp(false)}>
          <FeatherIcon size="14" icon="x" className="vx-icon mr-50" />
          ปิด
        </Button>
      </Modal.Footer>
    </Modal>
  )

  return (
    <>
      <Modal show={show}
        dialogClassName="modal-100w"
        onHide={() => onHide()}>
        <Modal.Header className="bg-primary" closeButton>
          {mode == 'search'
            ? 'ค้นหา Data Source'
            : mode == 'edit'
              ? 'แก้ไข Data Source'
              : 'สร้างรายการ Data Source ใหม่'}
        </Modal.Header>
        <Modal.Body row>
        {renderDSType()}
        {mode === 'search' ? renderSearchDataSource() : renderNewDataSource()}
        {state?.dataSourceType==='api' && renderDSAPI()}
        {['api'].includes(state?.dataSourceType) && (
          <Editor
            className="monaco-editor-custom"
            height="350px"            
            defaultLanguage="javascript"  // Set the default language as JavaScript
            defaultValue="// Start typing JavaScript code here"
            onMount={handleEditorDidMount}
            value={state['apiRespFunc']}
            options={{
              fontSize: 14, // Set the desired font size
            }}
            onChange={(newValue, e) => {
             // console.log('e', e)
              updateData('apiRespFunc', newValue)
            }}
          />
        )}
        {['db','exdb'].includes(state?.dataSourceType) && (<Row>
          <Col>
            <FormGroup>
              <div className="d-flex align-items-center">
                <Form.Label for="exampleText" className="mb-0">
                  Query e.g. {SAMPLE_QUERY}
                </Form.Label>
                {renderOptionalHelpButton()}
              </div>
              <Editor
                className="monaco-editor-custom"
                height="350px"
                defaultLanguage="sql"
                value={state['query']}
                options={{
                  fontSize: 14, // Set the desired font size
                }}
                onChange={(newValue, e) => {
               //   console.log('e', e)
                  updateData('query', newValue)
                }}
              />
            </FormGroup>
          </Col>
        </Row>)}
        <Row></Row>
        <Row>
          {normalizeInputs(state.inputs).map((item, index) => (
            <Col key={item}>
              {isDateInput(item)
                ? renderDateInput(item, item)
                : renderInput(item, item)}
            </Col>
          ))}
        </Row>
        <Row>
          <Col className="my-1">
            <Button onClick={() => checkQuery()}>
              <FeatherIcon
                size="16"
                icon="search"
                className="vx-icon "
              />

              ทดสอบค้นหา
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>{renderTable()}</Col>
        </Row>
        <Row>
          <Col></Col>
        </Row>
        </Modal.Body>
        <Modal.Footer row>
          {mode === 'search' &&
            state.dataSourceId &&
            state.dataSourceId > 0 && (
              <div>
                <Button
                  color="danger"
                  className="mr-50"
                  onClick={() => onModalDelete()}
                >
                  <FeatherIcon
                    size="16"
                    icon="trash"
                    className="vx-icon"
                  />

                  ลบ
                </Button>
                <Button className="mr-50" onClick={() => onModalSelect()}>
                  <FeatherIcon
                    size="16"
                    icon="download"
                    className="vx-icon"
                  />

                  เลือกใส่ลงหน้า Data Source
                </Button>
                <Button color="primary" onClick={() => onModalSave()}>
                  <FeatherIcon
                    size="16"
                    icon="save"
                    className="vx-icon"
                  />

                  บันทึกแก้ไข
                </Button>
              </div>
            )}
          {mode === 'edit' && (
            <Button color="primary" onClick={() => onModalSave()}>
              <FeatherIcon
                size="16"
                icon="save"
                className="vx-icon "
              />
              บันทึกแก้ไข
            </Button>
          )}
          {mode == 'new' && (
            <Button color="primary" onClick={() => onModalSave()}>
              <FeatherIcon
                size="16"
                icon="save"
                className="vx-icon"
              />

              บันทึกสร้างใหม่
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      {renderOptionalHelpModal()}
    </>
  )
}
